import InboomaBaseModel from "./InboomaBaseModel";

export default InboomaBaseModel.extend({
  urlRoot: "/charts/getTrips",

  _rbac: {
    admin: {
      read: true,
      write: true,
      edit: true,
      remove: true,
    },
    manager: {
      read: true,
      write: true,
      edit: true,
      remove: true,
    },
    user: {
      read: false,
      write: false,
      edit: false,
      remove: false,
    },
    "booking-manager": {
      read: false,
      write: false,
      edit: false,
      remove: false,
    },
    "manager-location": {
      read: false,
      write: false,
      edit: false,
      remove: false,
    },
    mediator: {
      read: false,
      write: false,
      edit: false,
      remove: false,
    },
    "garage-staff": {
      read: false,
      write: false,
      edit: false,
      remove: false,
    },
    guide: {
      read: false,
      write: false,
      edit: false,
      remove: false,
    },
  },
});
